// extracted by mini-css-extract-plugin
module.exports = {"centerAlignContent":"style_centerAlignContent__1mDH5","content":"style_content__1mu69"};